import { Link } from 'react-router-dom';
import { useAuth } from '../../services/authContext';
import './homeMinimal.css';

function Home() {
  const { user } = useAuth();

  return (
    <main className="home-min">
      <h1>Psy-Trainer — психологические тесты онлайн</h1>
      <p className="home-min__lead">
        Безопасное пространство для самооценки состояния, прохождения проверенных опросников и
        отслеживания динамики.
      </p>
      <div className="home-min__actions">
        {user ? (
          <>
            <Link to="/tests" className="ui-btn ui-btn-primary">
              Начать тест
            </Link>
            <Link to="/results" className="ui-btn ui-btn-ghost">
              Мои результаты
            </Link>
          </>
        ) : (
          <>
            <Link to="/tests" className="ui-btn ui-btn-primary">
              Посмотреть тесты
            </Link>
            <Link to="/login" className="ui-btn ui-btn-ghost">
              Войти
            </Link>
          </>
        )}
      </div>

      <section className="home-min__section" aria-labelledby="home-how-heading">
        <h2 id="home-how-heading">Всего четыре простых шага</h2>
        <div className="home-min__grid home-min__grid--steps">
          <article className="home-min__card ui-card">
            <div className="home-min__icon" aria-hidden>📝</div>
            <h3 className="home-min__card-title">Выбор теста</h3>
            <p>
              Найдите в каталоге подходящий опросник по теме и уровню сложности.
            </p>
          </article>
          <article className="home-min__card ui-card">
            <div className="home-min__icon" aria-hidden>⏱️</div>
            <h3 className="home-min__card-title">Прохождение</h3>
            <p>
              Ответьте на вопросы в спокойном режиме, уложившись в отведённое время.
            </p>
          </article>
          <article className="home-min__card ui-card">
            <div className="home-min__icon" aria-hidden>📊</div>
            <h3 className="home-min__card-title">Результаты</h3>
            <p>
              Получите понятную интерпретацию и опору для размышлений — без диагнозов и назначений
              «с сайта».
            </p>
          </article>
          <article className="home-min__card ui-card">
            <div className="home-min__icon" aria-hidden>📈</div>
            <h3 className="home-min__card-title">Отслеживание</h3>
            <p>
              Сравнивайте прохождения во времени и замечайте изменения в динамике.
            </p>
          </article>
        </div>
      </section>

      <section className="home-min__section" aria-labelledby="home-why-heading">
        <h2 id="home-why-heading">Почему выбирают наш тренажёр</h2>
        <div className="home-min__grid home-min__grid--benefits">
          <article className="home-min__card ui-card">
            <h3 className="home-min__card-title">🎯 Разнообразие тестов</h3>
            <p>
              Темы от самочувствия до устойчивости — единый удобный формат и понятные описания.
            </p>
          </article>
          <article className="home-min__card ui-card">
            <h3 className="home-min__card-title">📱 Удобный интерфейс</h3>
            <p>
              Быстрый старт с телефона или компьютера, без перегруженных экранов и лишних шагов.
            </p>
          </article>
          <article className="home-min__card ui-card">
            <h3 className="home-min__card-title">📊 Статистика и история</h3>
            <p>
              Для зарегистрированных пользователей — сохранённые результаты и обзор прогресса.
            </p>
          </article>
        </div>
      </section>
    </main>
  );
}

export default Home;
